import angular from "angular";

angular
	.module('app')
	.component('moderatorApplicationEdit', {
		template: require('./moderator-application-edit.html'),
        controller: ['$http', controller],
        bindings: {
		    application: '<',
        }
    });

function controller($http) {

	let $ctrl = this;

	$ctrl.$onInit = function () {
    };

	$ctrl.delete = (mode) => {

	    if(!confirm('Вы точно хотите убрать пользователя?')) {
            return;
        }

		let url = '/moderator/applications/' + $ctrl.application.id + '/delete-user';

		let params = {
			mode: mode,
		}

		$http.post(url, params).then((res) => {
			if (mode === 'tr')
				$ctrl.application.tr = null;
			else if (mode === 'fin')
				$ctrl.application.fin = null;
			else if (mode === 'buh')
				$ctrl.application.buh = null;

            window.Swal.fire({
                icon: 'success',
                title: 'Удалено!',
            });
		}, (er) => {
			console.log('error');
		})
	}

    $ctrl.showAppCar = function (carIndex) {
        $ctrl.application.app_cars[carIndex].show = !$ctrl.application.app_cars[carIndex].show;
    }

    $ctrl.deleteApp = () => {

	    if (!confirm('Вы точно хотите удалить заявку?')) {
	        return ;
        }

	    let url = '/moderator/applications/' + $ctrl.application.id + '/destroy';

	    $http.post(url).then((res) => {
	        window.Swal.fire({
                icon: 'success',
                title: 'Удалено!'
            }).then(() => {
                window.location = '/moderator/applications';
            })
        })
    }
}
